export enum JournalEntriesForms {
  UploadLedgerData = 'uploadLedgerData',
}
